import React from 'react';

interface LogoProps {
    width: string;
    height: number;
    color: string;
    [x: string]: any;
}

const Logo = ({ width, height, color = '#fff', ...otherProps }: LogoProps) => (
    <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1151.92 802.013' width={1.436 * height} height={height} {...otherProps}>
        <path
            d='M250.31 375.464H125.158V125.159h125.154c68.961 0 125.153 56.19 125.153 125.152s-56.192 125.153-125.153 125.153zm0 301.39H125.158V426.548h125.154c68.961 0 125.153 56.192 125.153 125.154 0 68.962-56.192 125.154-125.153 125.154zm325.655-301.39H450.812V125.159h125.153c68.963 0 125.154 56.19 125.154 125.152s-56.191 125.153-125.154 125.153zm0 301.39H450.812V426.548h125.153c68.963 0 125.154 56.192 125.154 125.154 0 68.962-56.191 125.154-125.154 125.154zm450.807-301.39H776.467V250.311c0-68.962 54.913-125.152 125.152-125.152 68.962 0 125.153 56.19 125.153 125.152zm0 301.39H776.467V426.548h250.305v250.308'
            fill={color}
        />
    </svg>
);

export default Logo;
